import { render } from "./Kingdom.vue?vue&type=template&id=53b4fcc4&scoped=true"
import script from "./Kingdom.vue?vue&type=script&lang=js"
export * from "./Kingdom.vue?vue&type=script&lang=js"

import "./Kingdom.vue?vue&type=style&index=0&id=53b4fcc4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53b4fcc4"]])

export default __exports__